import SAPStaffAugHome from "../../componentLayer/pages/services/Technology/sap/SAPStaffAugHome.jsx";
import OdooStaffHome from "../../componentLayer/pages/services/Technology/Odoo/OdooStaffHome.jsx";
import WebStaffHome from "../../componentLayer/pages/services/Technology/web&App/WebStaffHome.jsx";
import AIMLStaffHome from '../../componentLayer/pages/services/Technology/AI&ML/AIMLStaffHome.jsx';
import InforStaffHome from '../../componentLayer/pages/services/Technology/Infor/InforStaffHome.jsx';
import CloudStaffHome from '../../componentLayer/pages/services/Technology/Cloud/CloudStaffHome.jsx';
import IFSStaffHome from '../../componentLayer/pages/services/Technology/IFS/IFSStaffHome.jsx';
import EpicorStaffHome from '../../componentLayer/pages/services/Technology/Epicor/EpicorStaffHome.jsx';
import CyberSecurityStaffHome from '../../componentLayer/pages/services/Technology/CyberSecurity/CyberSecurityStaffHome.jsx';

import PermanentStaffing from "../../componentLayer/pages/services/StaffingServices/PermanentStaffing/PermanentStaffing.jsx";
import ContractStaffing from "../../componentLayer/pages/services/StaffingServices/ContractStaffing/ContractStaffing.jsx";
import DirectHire from "../../componentLayer/pages/services/StaffingServices/DirectHire/DirectHire.jsx";
import ContractToHire from "../../componentLayer/pages/services/StaffingServices/ContractToHire/ContractToHire.jsx";
import StatementOfWork from "../../componentLayer/pages/services/StaffingServices/StatementOfWork/StatementOfWork.jsx";
import OracleStaffHome from "../../componentLayer/pages/services/Technology/Oracle/OracleStaffHome.jsx";

export const serviceRouter = [
  {
    path: "erpservices",
    children: [
      {
        path: "sap",
        element: <SAPStaffAugHome />,
      },
      {
        path: "sap-staffing-service",
        element: <SAPStaffAugHome />,
      },
      {
        path: "odoo",
        element: <OdooStaffHome />,
      },
      {
        path: "odoo-staffing-service",
        element: <OdooStaffHome />,
      },
      {
        path: "infor",
        element: <InforStaffHome />,
      },
      {
        path: "infor-staffing-service",
        element: <InforStaffHome />,
      },
      {
        path: "oracle",
        element: <OracleStaffHome />,
      },
      {
        path: "oracle-staffing-service",
        element: <OracleStaffHome />,
      },
      {
        path: "ifs",
        element: <IFSStaffHome />,
      },
      {
        path: "ifs-staffing-service",
        element: <IFSStaffHome />,
      },
      {
        path: "epicor",
        element: <EpicorStaffHome />,
      },
      {
        path: "epicor-staffing-service",
        element: <EpicorStaffHome />,
      },
    ]
  },
  {
    path: "technology",
    children: [
      {
        path: "web-and-app-staffing-service",
        element: <WebStaffHome />,
      },
      {
        path: "ai-ml",
        element: <AIMLStaffHome />,
      },
      {
        path: "cloud",
        element: <CloudStaffHome />,
      },
      {
        path: "cybersecurity",
        element: <CyberSecurityStaffHome />,
      },
    ]
  },
  {
    path: "staffing-services",
    children: [
      {
        path: "permanent-staffing",
        element: <PermanentStaffing />,
      },
      {
        path: "contract-staffing",
        element: <ContractStaffing />,
      },
      {
        path: "direct-hire",
        element: <DirectHire />,
      },
      {
        path: "contract-to-hire",
        element: <ContractToHire />,
      },
      {
        path: "statement-of-work",
        element: <StatementOfWork />,
      },
    ]
  },
];
